import React from "react";
import copartLogo from "../assets/cprt.webp"; 

export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-108px)] bg-white">
      <div
        className="relative flex items-center justify-center"
        style={{
          width: 1100, 
          height: 600,
          background: `url(${copartLogo}) center/cover no-repeat`,
          borderRadius: "80% / 80%",
          marginTop: "20px",
        }}
      >
        <h1
          className="absolute top-[20%] left-1/2 text-5xl font-medium text-white"
          style={{
            transform: "translateX(-50%)",
            textShadow: "0 2px 8px rgba(0,0,0,0.5)",
            letterSpacing: "1px",
            whiteSpace: "nowrap",
          }}
        >
          Welcome to UBIQUITY!
        </h1>
      </div>
    </div>
  );
}